import { Map } from 'immutable';

let selectOptions = [
  { label: 'Continuous', options: [
    {label: 'Acres (total)', value: 'acres'}
    //{label: 'Acres (owned)', value: 'acres_owned'},
    //{label: 'Dollar Value', value: 'value'}
  ]},
  { label: 'Discrete', options: [
    {label: 'Owner', value: 'owner'},
    {label: 'Legal Entity', value: 'legal_entity'},
    {label: 'Status', value: 'include'}
    //{label: 'Core Plantation', value: 'is_core'},
    //{label: 'Portion Reserved at Closing', value: 'portion_reserved_at_closing'},
    //{label: 'Deregistration Submitted', value: 'request_for_deregistration_submitted'},
    //{label: 'Title Insurable', value: 'is_title_insurable'},
    //{label: 'IAL', value: 'is_ial'},
    //{label: 'A&B Risk Rank', value: 'ab_risk_rank'}
    //{label: 'Initial Risk Rank', value: 'm_risk_rank'}
  ]}
];

/* * * * * * * * * StatApp Reducer * * * * * * * * */
let initialState = Map({
  "selectOptions": selectOptions,
  "showProperties": true,
  "fillProperties": true,
  "showRadius": true,
  "radius":"max",
  "parameters": Map(),
  "parameter": {'value': 'include', 'label': 'Status'},
  "parameterType": 'Discrete',
  "histogramSelection":[null,null],
  "showQuantile":false,
  "quantileSize":[500,350],
  "showUITools": false,
  "uiSize":[500,350],
  "showHotSpot": false,
  "showClusters": false,
  "showGrid": false,
  "showContours": false,
  "mapBreaks": 'ckmeans',
  "showInfoLegend": true,
  "errorMessage": null
});

const StatApp = (state = initialState, action) => {

  var newState = Map();

  switch(action.type){

    /* * * * * * * * * ACTION RECEIVE DATA * * * * * * * * */
    case "ERROR":
      return state.set('errorMessage', action.message);

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null);

    case "RECEIVE_DATA":
      return state.set('errorMessage', null)
        .set('histogramSelection', [null,null])
        .set('showBoxPlot', false)
        .set('showQuantile', false)
        .set('showUITools', false)
        .set('showHotSpot', false)
        .set('showSamplingFreq', false)
        .set('showClusters', false)
        .set('showGrid', false)
        .set('showContours', false)
        .set('showBands', false)
        .set('showWaterLevels', false)
        .set('waterLevelTimeStep', 1)
        .set('showModelResults', false)
        .set('modelTimeStep', 1)
        .set('modelDepthStep', 1)

    /* * * * * * * * * STAT STUFF * * * * * * * * */
    case "CHOOSE_RADIUS":
      return state.set('radius', action.value).set('histogramSelection',[null,null]);

    case "CHANGE_PARAMETER":
      return state.set('parameter', action.value).set('parameterType', (action.value.value === 'value' || action.value.value === 'acres_owned' || action.value.value === 'acres') ? 'Continuous' : 'Discrete')

    case "CHOOSE_HISTOGRAM":
      var histogramSelection = action.x0 === state.get('histogramSelection') ? null : [action.x0, action.x1]
      return state.set('histogramSelection', histogramSelection)

    case "TOGGLE_SHOW_PROPERTIES":
      return state.set('showProperties', !state.get('showProperties'))

    case "TOGGLE_SHOW_FILL":
      return state.set('fillProperties', !state.get('fillProperties'))


    /* * * * * * * * * PLOT MODAL STUFF * * * * * * * * */
    case "TOGGLE_PLOT_MODAL":
      var uiTools = false;
      switch(action.plot) {
        case 'quantile':
          return state.set('showQuantile', !state.get('showQuantile'));
        case 'piper':
          return state.set('showPiper', !state.get('showPiper'));
        case 'modpiper':
          return state.set('showModifiedPiper', !state.get('showModifiedPiper'));
        case 'durov':
          return state.set('showDurov', !state.get('showDurov'));
        case 'hotspot':
          return state.set('showHotSpot', !state.get('showHotSpot'));
        case 'sampling':
          return state.set('showSamplingFreq', !state.get('showSamplingFreq'));
        case 'grid':
          newState = state.set('showGrid', !state.get('showGrid'));
          uiTools = newState.get('showGrid') || newState.get('showContours') || newState.get('showClusters')
          return newState.set('showUITools', uiTools);
        case 'bands':
          return state.set('showBands', !state.get('showBands'));
        case 'contour':
          newState = state.set('showContours', !state.get('showContours'));
          uiTools = newState.get('showGrid') || newState.get('showContours') || newState.get('showClusters')
          return newState.set('showUITools', uiTools);
        case 'tin':
          return state.set('showTin', !state.get('showTin'));
        case 'cluster':
          newState = state.set('showClusters', !state.get('showClusters'))
          uiTools = newState.get('showGrid') || newState.get('showContours') || newState.get('showClusters')
          return newState.set('showUITools', uiTools);
        case 'boxplot':
          return state.set('showBoxPlot', !state.get('showBoxPlot'));
        default:
          return state;
      }

    case "RESIZE_PLOT_MODAL":
      switch(action.plot) {
        case 'quantile':
          return state.set('quantileSize', [action.width, action.height]);
        case 'boxplot':
          return state.set('boxPlotSize', [action.width, action.height]);
        case 'ui':
          return state.set('uiSize', [action.width, action.height]);
        default:
          return state;
      }

      case "UPDATE_SLIDER_STEP":
        switch(action.slider) {
          case 'levels':
            return state.set('waterLevelTimeStep', parseInt(action.value, 10))

          case 'model_times':
            return state.set('modelTimeStep', parseInt(action.value, 10))

          case 'model_depths':
            return state.set('modelDepthStep', parseInt(action.value, 10))

          default:
            return state;

        }


      default:
        return state
  }
}

export default StatApp;



// WEBPACK FOOTER //
// ./src/reducers/stat.js